import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private secretKey = 'your-secret-key'; // Replace with a strong secret key

  constructor() {}

  // Encrypts data using AES encryption
  encryptData(data: any): any {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
    } catch (error) {
      //console.error('Encryption error:', error);
      return null; // Return null if encryption fails
    }
  }

  // Decrypts AES encrypted data
  decryptData(encryptedData: string): any {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

      // Check if decryption was successful
      if (!decryptedText) throw new Error('Decryption failed, malformed data');

      return JSON.parse(decryptedText); // Parse the decrypted text
    } catch (error) {
      //console.error('Decryption error:', error);
      return null; // Return null if decryption fails
    }
  }

  // Sets an encrypted item in localStorage
  setItem(key: string, data: any): void {
    const encryptedData = this.encryptData(data);
    if (encryptedData) {
      localStorage.setItem(key, encryptedData);
    } else {
      // console.error(`Failed to store ${key}: encryption failed`);
    }
  }

  // Retrieves an item from localStorage, decrypting it
  getItem(key: string): any {
    const encryptedData = localStorage.getItem(key);
    if (encryptedData) {
      return this.decryptData(encryptedData);
    }
    return null;
  }

  // Removes a specific item from localStorage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clears all items from localStorage
  clear(): void {
    localStorage.clear();
  }
}
